export const style = {
  white: '#ffffff',
  black: '#000000',
  brandPrimary: '#00416a',
  brandDanger: '#a00000',
  grayDarker: '#222222',
  grayDark: '#333333',
  grayLighter: '#eeeeee',

  activeLink: {
    borderBottomStyle: 'solid',
    borderBottomWidth: '1.5px',
  },

  childrenMarginLeftHalfx: {
    '& > *+*': {
      marginLeft: '0.5rem',
    },
  },
  childrenMarginLeft1x: {
    '& > *+*': {
      marginLeft: '1rem',
    },
  },
  childrenMarginLeft4x: {
    '& > *+*': {
      marginLeft: '4rem',
    },
  },

  childrenMarginTopHalfx: {
    '& > *+*': {
      marginTop: '0.5em',
    },
  },
  childrenMarginTop1x: {
    '& > *+*': {
      marginTop: '1em',
    },
  },
  childrenMarginTop4x: {
    '& > *+*': {
      marginTop: '4em',
    },
  },

  childrenBorderTop: {
    '& > *+*': {
      borderTop: '1.5px solid #808080',
    },
  },
};
